export default 'Value must be {0} or earlier.';